/* src/app/components/add-tank-modal/add-tank-modal.component.scss */
.onboarding-message {
  text-align: center;
  padding: 16px;
  margin-bottom: 16px;
  background: var(--ion-color-primary);
  border-radius: 12px;
}
.onboarding-message .onboarding-icon {
  font-size: 48px;
  margin-bottom: 12px;
  color: white;
}
.onboarding-message p {
  color: white;
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}
.onboarding-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 24px;
  padding: 12px;
  background: var(--ion-color-light);
  border-radius: 8px;
  font-size: 13px;
}
.onboarding-tip ion-icon {
  color: var(--ion-color-warning);
  font-size: 18px;
  flex-shrink: 0;
}
ion-list {
  background: transparent;
}
ion-item {
  --background: var(--ion-color-light);
  border-radius: 8px;
  margin-bottom: 12px;
}
/*# sourceMappingURL=add-tank-modal.component.css.map */
